import React from 'react';

import { MomentPanel } from './WritingAssistMoments.styles';

export type WritingAssistNoticeKind =
  | 'talent_daily_limit'
  | 'location_daily_limit'
  | 'burst_limit'
  | 'writer_failure'
  | 'incoherent_input'
  | 'gate_unavailable';

export interface WritingAssistNoticeProps {
  kind: WritingAssistNoticeKind;
  limit?: number;
}

export function writingAssistNoticeCopy(
  kind: WritingAssistNoticeKind,
  limit?: number,
): string | null {
  if (kind === 'talent_daily_limit' || kind === 'location_daily_limit') {
    if (!Number.isSafeInteger(limit) || Number(limit) <= 0 || Number(limit) > 1000) return null;
    return kind === 'talent_daily_limit'
      ? `You've used all ${limit} of today's AI polishes. They refresh tomorrow — and you can save your own writing anytime.`
      : `This location has used today's ${limit} AI polishes. They refresh tomorrow.`;
  }
  if (kind === 'burst_limit') {
    return 'A few too many requests at once — give it a moment and try again.';
  }
  if (kind === 'writer_failure') {
    return "We couldn't prepare suggestions just now. Your text is safe — try again in a minute, or save as-is.";
  }
  if (kind === 'incoherent_input') {
    return "We couldn't quite follow this one, so no suggestions yet. Mind giving it another pass in your own words?";
  }
  // WA-L-06 is deliberately silent: launch gate failures fail open and must
  // never introduce a false user-visible error state.
  return null;
}

const WritingAssistNotice: React.FC<WritingAssistNoticeProps> = ({ kind, limit }) => {
  const copy = writingAssistNoticeCopy(kind, limit);
  if (!copy) return null;
  return (
    <MomentPanel role="alert">
      <p>{copy}</p>
    </MomentPanel>
  );
};

export default WritingAssistNotice;
